exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-spinner[data-v-e944586c]{display:inline-block}.loading-spinner .loading-text[data-v-e944586c]{text-align:center;margin-top:8px;font-size:14px}.loading-spinner--lg .loading-text[data-v-e944586c]{margin-top:12px;font-size:20px}.loading-spinner[data-v-e944586c] svg{-webkit-animation:spin .5s ease-in infinite forwards;animation:spin .5s ease-in infinite forwards}", ""]);

// exports
